import API from './API.js';
export default class MasterSemenar extends API {
    constructor() {
        super('masterSemenar');
    }

}
